import * as type from "../types";
import { get, deleteReq, post, put } from './../../config/Requests';
import { setData } from './../helpers';
import { notArrayOrEmpty } from "../../utils/helpers";
import { reportsListRoute, reportsPendingReportsRoute, reportsAutomaticReportsRoute, settingsAddFile } from './../../config/routes';
import { openSnackbarInfoDispatch, startLoader } from "./requestAction";
import t from "../../languages/pl";
import instance from "../../config/axiosConfig";
import { tokenIdentifier } from '../../utils/staticData';
import { getToken } from '../../config/sessionData';

export const getReports = () => {

    return dispatch => {

        get(
            dispatch,
            reportsListRoute,
            { },
            response => {
                setData(dispatch, type.SET_REPORTS, response);
                dispatch({
                        type: type.SET_KEYWORDS_LIST,
                        value: collectKeywords(response.data[1])
                    });
            }
        );
    };
};

const collectKeywords = (reports) => {
    if (notArrayOrEmpty(reports))
        return [];
    let allReportsKeywords = [];
    reports.forEach(report => {
        let tags = report.tagi;
        allReportsKeywords = [...allReportsKeywords, ...tags];
    });
    return [...new Set(allReportsKeywords)];
};

export const selectReport = (id) => {
    return dispatch => {
        dispatch({
            type: type.SELECT_REPORT,
            value: id
        });
    };
};

export const getPendingReportsOnOpen = () => {
    return dispatch => {
        startLoader(dispatch);
        let config = {
            headers: { [tokenIdentifier]: getToken() },
            params: {}
        };
        instance
        .get(reportsPendingReportsRoute, config)
        .then(response => setData(dispatch, type.SET_PENDING_LIST, response));
    };
};

export const getPendingReports = () => {
    return dispatch => {
        getAsyncPendingReports(dispatch);
    };
};

const getAsyncPendingReports = async (dispatch) => {
        get(
            dispatch,
            reportsPendingReportsRoute,
            { },
            response => {
                setData(dispatch, type.SET_PENDING_LIST, response);
            }
        );
};

export const deletePendingReport = id => {
    return (dispatch, getState) => {
        let pendingReports = getState().reportReducer.pendingList;
        let newList = pendingReports.filter(report => report.raport_id !== id);
        deleteReq(
            dispatch,
            reportsPendingReportsRoute,
            {raport_id: id},
            () => {
                dispatch({
                    type: type.SET_PENDING_LIST,
                    value: newList
                });
                openSnackbarInfoDispatch(dispatch, t.pendingReportHasBeenRemoved);
            }
        );
    };
};

export const getAutomaticReports = () => {
    return dispatch => {
        get(
            dispatch,
            reportsAutomaticReportsRoute,
            { },
            response => {
                setData(dispatch, type.SET_AUTOMATIC_REPORT_LIST, response);
            }
        );
    };
};

export const postReport = (report) => {
    return (dispatch, getState) => {
        post(
            dispatch,
            reportsListRoute,
            report,
            (response) => {
                dispatch({
                    type: type.SET_FILE_ID,
                    value: null
                });
                if (report.cykl === null) {
                    const pendingReports = getState().reportReducer.pendingList;
                    const updatedReport = {
                        ...report,
                        raport_id: response.data.raport_id,
                        data: response.data.data,
                        nr_w_kolejce: response.data.nr_w_kolejce,
                        typ: response.data.typ,
                        nazwa_pliku: report.nazwapliku,
                        stan: 0
                    };
                    const updatedPendingReports = pendingReports.concat(updatedReport);
                    dispatch({
                        type: type.SET_PENDING_LIST,
                        value: updatedPendingReports
                    });
                } else {
                    const automaticReports = getState().reportReducer.automaticReportList;
                    const updatedReport = {
                        ...report,
                        raport_id: response.data.raport_id,
                        typ: response.data.typ,
                        nazwa_pliku: report.nazwapliku,
                    };
                    const updatedAutomaticReports = automaticReports.concat(updatedReport);
                    dispatch({
                        type: type.SET_AUTOMATIC_REPORT_LIST,
                        value: updatedAutomaticReports
                    });
                }
                openSnackbarInfoDispatch(dispatch, t.reportHasBeenAdded);
            }
        );
    };
};

export const putAutomaticReport = (id, report, reportType) => {
    return (dispatch, getState) => {
        delete report.raport_id;
        put(
            dispatch,
            reportsAutomaticReportsRoute,
            { raport_id: id },
            report,
            () => {
                const automaticReports = getState().reportReducer.automaticReportList;
                const selectedReport = automaticReports.find(automaticReport => automaticReport.raport_id === id);
                const index = automaticReports.findIndex(r => r.raport_id === selectedReport.raport_id);
                let updatedAutomaticReports = automaticReports;
                updatedAutomaticReports[index] = { ...report, nazwa_pliku: report.nazwapliku, typ: reportType, raport_id: id };
                dispatch({
                    type: type.SET_AUTOMATIC_REPORT_LIST,
                    value: updatedAutomaticReports
                });
            }
        );
    };
};

export const deleteAutomaticReport = id => {
    return (dispatch, getState) => {
        const automaticReports = getState().reportReducer.automaticReportList;
        const newList = automaticReports.filter(report => report.raport_id !== id);
        deleteReq(
            dispatch,
            reportsAutomaticReportsRoute,
            { raport_id: id },
            () => {
                dispatch({
                    type: type.SET_AUTOMATIC_REPORT_LIST,
                    value: newList
                });
                openSnackbarInfoDispatch(dispatch, t.automaticReportHasBeenRemoved);
            }
        );
    };
};

export const postFile = (data) => {
    return (dispatch) => {
        post(
            dispatch,
            settingsAddFile,
            data,
            (response) => {
                dispatch({
                    type: type.SET_FILE_ID,
                    value: response.data.plik_id
                });
                openSnackbarInfoDispatch(dispatch, t.fileHasBeenAdded);
            }
        );
    };
};
